
<user-navigation></user-navigation>

<div class="container-fluid">
    <div id="top"></div>
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4 profile-side-bar">
            <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mb-5 mb-md-0" id="side-nav">
                            <div id="page-redirection">
                                <a routerLink="/user/profile">
                                    <img src="../../../../assets/images/arrows/back_arrow.png">
                                    Back to Account
                                </a>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show" role="alert"
                                *ngIf="error">
                                {{ errorMsg }}
                            </div>
                            <h3 class="display-4 box-title">Delivery Address</h3>
                            <form class="mt-4 mt-md-4" [formGroup]="addressForm" (ngSubmit)="onSubmit()">

                                <!-- Success Message -->
                                <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="success">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="success = !success">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                    Delivery Address was successfully updated
                                </div>

                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="line1"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.line1.invalid) || (f.line1.dirty && f.line1.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Street Address 1*</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="line2"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.line2.invalid) || (f.line2.dirty && f.line2.invalid)}"
                                        (focusout)="resetLine2Error()"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Street Address 2</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="suburb"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.suburb.invalid) || (f.suburb.dirty && f.suburb.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Suburb*</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="city"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.city.invalid) || (f.city.dirty && f.city.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>City*</label>
                                </div>
                                <div class="md-input post-code">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="postcode"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.postcode.invalid) || (f.postcode.dirty && f.postcode.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Post Code*</label>
                                </div>
                                <div class="col-md-12 country-container" *ngIf="countries?.length > 0">
                                    <select
                                        class="country-select form-control"
                                        [ngClass]="{'error': countryError}"
                                    >
                                        <option selected=""></option>
                                        <option *ngFor="let data of countries" [value]="data.id">{{ data.value }}</option>
                                    </select>
                                    <div class="text-left">
                                        <label class="countryLabel">Country</label>
                                    </div>
                                </div>


                                <button type="submit" class="btn btn-primary btn-block btn-submit mt-md-5 mt-5">
                                    Save
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>

<footer-main></footer-main>
